<template>

  <div id="call-records-view" class="page-table scrollable only-y">
    <el-dialog
      width="440px"
      :visible="modalVisible"
      :before-close="handleCloseModal"
    >
      <h2 class="form-section-header">
        Filter Settings
      </h2>

      <h3 class="black-text mb-5">Select Date Range</h3>
      <el-date-picker
        :clearable="false"
        class="mr-10"
        style="margin-left: auto;"
        v-model="historyDateRange"
        type="datetimerange"
        format="yyyy-MM-dd HH:mm"
        align="right"
        unlink-panels
        range-separator="To"
        start-placeholder="Start date"
        end-placeholder="End date"
        :picker-options="datePickerOptions">
      </el-date-picker>

      <el-form id="records-advanced-modal" class="form-modal">

        <h3 class="black-text mb-5">Call Direction</h3>
        <el-radio-group v-model="direction">
          <el-radio-button type="default" label="Inbound">Inbound</el-radio-button>
          <el-radio-button label="Outbound">Outbound</el-radio-button>
          <el-radio-button label="Internal">Internal</el-radio-button>
          <el-radio-button label="All">All</el-radio-button>
        </el-radio-group>

        <h3 class="black-text mb-5 mt-20">Select Call Records Dispositions</h3>
        <el-checkbox-group v-model="dispositions" class="flex column dispositions-group">
          <el-checkbox label="ANSWERED">Answered</el-checkbox>
          <el-checkbox label="NO ANSWER">No Answer</el-checkbox>
          <el-checkbox label="BUSY">Busy</el-checkbox>
          <el-checkbox label="FAILED">Failed</el-checkbox>
        </el-checkbox-group>

        <el-button
          @click="doAdvanced"
          class="mt-20"
        >
          Update
        </el-button>
      </el-form>

    </el-dialog>

    <div class="no-table-box page-header">

        <div class="flex justify-space-between mb-10">
          <h2 class="mb-0 mt-0 text-left">
            <v-svg sprite="flow" class="voxo-blue"></v-svg>
            Call Records
          </h2>
          <el-tag>
            <i class="el-icon-info" style="margin-right: 4px;"></i>
            Total: {{ total | number }}
          </el-tag>
        </div>

        <div class="flex align-center mb-10">
          <el-radio-group v-model="presetSelection" @change="doPreset">
            <el-radio-button type="default" label="last10">Last 10 Days</el-radio-button>
            <el-radio-button label="lastMonth">Last 30 Days</el-radio-button>
          </el-radio-group>
          <el-tooltip placement="top" :content="selectedDateRange">
            <el-button
              @click="modalVisible = true;"
              class="ml-10"
            >
              Filter
            </el-button>
          </el-tooltip>
          <el-button
            @click="resetTable"
            v-if="advancedActive"
            style="background-color: #f25a6b; color: #fff;"
          >
            Reset
          </el-button>
          <el-pagination
            small
            background
            layout="prev, pager, next"
            @current-change="pageSet"
            @next-click="pageNext"
            @prev-click="pagePrevious"
            :current-page="page"
            :page-size="50"
            :pager-count="5"
            :total="total"
            v-if="total > limit"
            style="margin-left: auto;"
          />
        </div>

      <div class="vxe-table-height-tabs card-base card-shadow--medium">
        <vxe-grid
          round
          border="inner"
          ref="xGrid"
          height="100%"
          auto-resize
          empty-text="No Data"
          show-overflow="tooltip"
          highlight-hover-row
          :data="tableData"
          :scroll-y="{ enabled: true, gt: 50, oSize: 0 }"
          :loading="loadingData"
          :columns="tableColumns"
        />
      </div>
    </div>


  </div>

</template>

<script>

  import feathersClient from '@/feathers/feathers-client';
  import debounce from 'lodash/debounce';
  import moment from "moment";
  import {phoneNumberFormatter} from "@/globals/globals";

  export default {
    name: 'CallRecordsTable',
    data() {
      return {
        visibleActionsId: null,
        search: '',
        page: 1,
        limit: 50,
        total: 0,
        loadingData: false,
        advancedActive: false,
        modalVisible: false,
        presetSelection: 'last10',
        tableData: [],
        dispositions: ['ANSWERED', 'NO ANSWER', 'BUSY', 'FAILED'],
        primaryFilter: 'user',
        extNumber: '',
        startDate: null,
        endDate: null,
        direction: 'All',
        historyDateRange: [
          moment(),
          moment()
        ],
        datePickerOptions: {
          shortcuts: [{
            text: 'Last week',
            onClick(picker) {
              const end = moment(moment().format('YYYY-MM-DD')).add(1, 'day').subtract(1, 'minute');
              const start = moment(moment().subtract(1, 'week').format('YYYY-MM-DD'));
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: 'Last month',
            onClick(picker) {
              const end = moment(moment().format('YYYY-MM-DD')).add(1, 'day').subtract(1, 'minute');
              const start = moment(moment().subtract(1, 'month').format('YYYY-MM-DD'));
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: 'Last 3 months',
            onClick(picker) {
              const end = moment(moment().format('YYYY-MM-DD')).add(1, 'day').subtract(1, 'minute');
              const start = moment(moment().subtract(3, 'months').format('YYYY-MM-DD'));
              picker.$emit('pick', [start, end]);
            }
          }],
          disabledDate(time) {
            const difference = moment(time).diff(moment(), 'days');
            return !(difference > -181 && difference < 1);
          }
        },
        tableColumns: [
          {
            field: 'sprite',
            title: '',
            width: 50,
            slots: {
              default: ({row}) => {
                return [
                  <div class="voxo-square-icon voxo-bg-btn">
                    <v-svg class="voxo-blue" sprite="flow"/>
                  </div>
                ]
              }
            }
          },
          {
            field: 'start',
            title: 'Time',
            minWidth: 150,
            slots: {
              default: ({row}) => {
                return [
                  <span>{this.timeFormatter(row.start)}</span>
                ]
              }
            }
          },
          {
            field: 'callerIdNumber',
            title: 'Caller Number',
            minWidth: 150,
            showOverflow: true,
            slots: {
              default: ({row}) => {
                return [
                  <span>{this.numberFormatter(row.callerIdNumber)}</span>
                ]
              }
            }
          },
          {
            field: 'callerIdName',
            title: 'Caller Name',
            minWidth: 200,
            showOverflow: true
          },
          {
            field: 'dialedNum',
            title: 'Dialed Number',
            minWidth: 150,
            slots: {
              default: ({row}) => {
                return [
                  <span>{this.numberFormatter(row.dialedNum)}</span>
                ]
              }
            }
          },
          {
            field: 'direction',
            title: 'Direction',
            minWidth: 125
          },
          {
            field: 'disposition',
            title: 'Disposition',
            minWidth: 150
          },
          {
            field: 'presented',
            title: 'Presented',
            minWidth: 100
          },
          {
            field: 'duration',
            title: 'Duration',
            minWidth: 100,
            slots: {
              default: ({row}) => {
                return [
                  <span>{this.convertTime(row.duration)}</span>
                ]
              }
            }
          },
          {
            field: 'packetLoss',
            title: 'Packet Loss',
            minWidth: 120,
            slots: {
              default: ({row}) => {
                return [
                  <span>{row.qos ? `${row.packetLoss} %` : 'N/A'}</span>
                ]
              }
            }
          },
          {
            field: 'percentJitter',
            title: 'Jitter',
            minWidth: 100,
            slots: {
              default: ({row}) => {
                return [
                  <span>{row.qos ? `${row.percentJitter} %` : 'N/A'}</span>
                ]
              }
            }
          },
          {
            field: 'mos',
            title: 'MOS',
            minWidth: 100
          }
        ]
      }
    },
    computed: {
      user() {
        return this.$store.state.auth.user;
      },
      userOffsetMinutes(){
        return this.$store.state.userTimeOffset;
      },
      selectedDateRange(){
        if(this.endDate && this.startDate){
          const dateStart = moment(this.startDate).format('M/D/YY HH:mm');
          const dateEnd = moment(this.endDate).format('M/D/YY HH:mm');
          return  `${dateStart} - ${dateEnd}`;
        }
      }
    },
    watch: {
      page: debounce(function () {
        this.queryCallRecords();
      }, 500)
    },
    methods: {
      queryCallRecords() {
        this.loadingData = true;
        feathersClient.service('call-history').find({
          query: {
            queryType: 'callHistory',
            tenantId: this.user.myExtension.tenantId,
            startDate: this.startDate,
            endDate: this.endDate,
            direction: this.direction,
            primaryFilter: this.primaryFilter,
            dispositions: this.dispositions,
            extNumber: this.user.myExtension.number,
            $sort: {start: -1},
            $limit: this.limit,
            $skip: this.page > 1 ? (this.limit * (this.page - 1)) : 0,
          }
        }).then( res => {
          this.limit = res.limit;
          this.pages = Math.ceil(res.total / res.limit);
          this.total = res.total;
          this.page = this.page > this.pages ? 1 : this.page;
          this.tableData = res.data;
          this.loadingData = false
        }).catch( () => {this.loadingData = false});
      },
      resetTable(){
        this.advancedActive = false;
        this.dispositions = ['ANSWERED', 'NO ANSWER', 'BUSY', 'FAILED'];
        this.advancedActive = false;
        this.direction = 'All';
        this.doPreset('init');
      },
      doPreset(val){

        if(val === 'init'){
          this.endDate = moment(moment().format('YYYY-MM-DD')).add(1, 'day').subtract(1, 'minute').format('YYYY-MM-DD HH:mm');
          this.startDate = moment().startOf('day').format('YYYY-MM-DD');
          this.presetSelection = 'init';
          this.updateDateRangePicker();
          this.queryCallRecords();
        }

        if(val === 'last10'){
          this.endDate = moment(moment().format('YYYY-MM-DD')).add(1, 'day').subtract(1, 'minute').format('YYYY-MM-DD HH:mm');
          this.startDate = moment().subtract(9, 'days').format('YYYY-MM-DD');
          this.presetSelection = 'last10';
          this.updateDateRangePicker();
          this.queryCallRecords();
        }

        if(val === 'lastMonth'){
          this.endDate = moment(moment().format('YYYY-MM-DD')).add(1, 'day').subtract(1, 'minute').format('YYYY-MM-DD HH:mm');
          this.startDate = moment().subtract(30, 'days').format('YYYY-MM-DD');
          this.presetSelection = 'lastMonth';
          this.updateDateRangePicker();
          this.queryCallRecords();
        }
      },
      doAdvanced(){
        this.startDate = moment(this.historyDateRange[0]).format('YYYY-MM-DD HH:mm');
        this.endDate = moment(this.historyDateRange[1]).format('YYYY-MM-DD HH:mm');
        this.queryCallRecords();
        this.handleCloseModal();
        this.advancedActive = true;
      },
      numberFormatter(val) {
        return phoneNumberFormatter(val);
      },
      timeFormatter(value) {

        const offsetMinutes = Math.abs(this.userOffsetMinutes);

        return this.userOffsetMinutes < 0
          ? moment(value).subtract(offsetMinutes, 'minutes').format('M/DD h:mm A')
          : moment(value).add(offsetMinutes, 'minutes').format('M/DD h:mm A');

      },
      convertTime(time) {

        const hours = Math.floor(time / 3600);
        const remainderSeconds = time % 3600;
        const minutes = Math.floor(remainderSeconds / 60);
        const seconds = Math.round(remainderSeconds % 60);

        if (hours > 0) {return hours + 'hr ' + minutes + 'm';}
        if (minutes > 0) {return minutes + 'm';}
        if (seconds > 0) {return seconds + 's';}
        return '0';
      },
      handleCloseModal(){
        this.modalVisible = false;
      },
      updateDateRangePicker(){
        this.historyDateRange = [
          moment(this.startDate),
          moment(this.endDate)
        ]
      },
      pageNext () {
        if (this.page < this.pages) {
          this.page += 1;
        }
      },
      pagePrevious () {
        if (this.page > 1) {
          this.page -= 1;
        }
      },
      pageSet (page) {
        this.page = page;
      }
    },
    mounted() {
      this.doPreset('init');
    },
    beforeDestroy() {
    },
    filters: {
      number (value) {
        return !isNaN(value)
          ? new Intl.NumberFormat('en-US').format(value)
          : value;
      }
    }
  }

</script>

<style lang="scss" scoped>

.dispositions-group{
  .el-checkbox{
    margin-left: 0;
  }
}

</style>
